// Sistem Ayarları — veri modeli ve varsayılan değerler.
// Tüm siteyi kontrol eden merkezi ayar havuzu (kurumsal yapı).

export interface SiteSettings {
  // Kurumsal Bilgiler
  companyName: string;
  legalName: string;
  taxOffice: string;
  taxNumber: string;
  tradeRegistry: string;
  address: string;
  city: string;
  postalCode: string;

  // Marka & Kimlik
  siteName: string;
  tagline: string;
  siteDescription: string;

  // İletişim & Sosyal
  contactEmail: string;
  supportPhone: string;
  whatsapp: string;
  instagram: string;
  twitter: string;
  youtube: string;
  linkedin: string;

  // Ödeme & Banka (Havale/EFT)
  bankName: string;
  bankAccountName: string;
  bankIban: string;
  paytrEnabled: boolean;

  // Kayıt & Üyelik
  registrationOpen: boolean;
  emailVerification: boolean;
  allowTeacherRegistration: boolean;
  allowParentRegistration: boolean;
  maxStudentsPerClass: number;

  // Bildirimler
  emailNotifications: boolean;
  smsNotifications: boolean;
  weeklyDigest: boolean;
  notifyOnNewRegistration: boolean;

  // Güvenlik & KVKK
  sessionTimeoutMin: number;
  requireStrongPassword: boolean;
  twoFactorRequired: boolean;

  // Gelişmiş
  maintenanceMode: boolean;
  maintenanceMessage: string;
  analyticsEnabled: boolean;
}

export interface SettingsTabProps {
  settings: SiteSettings;
  update: (patch: Partial<SiteSettings>) => void;
}

export const defaultSettings: SiteSettings = {
  companyName: "",
  legalName: "",
  taxOffice: "",
  taxNumber: "",
  tradeRegistry: "",
  address: "",
  city: "",
  postalCode: "",

  siteName: "DersDinle",
  tagline: "Derslerin Sesi, Başarının Yolu...",
  siteDescription:
    "Okul öncesinden sınav hazırlığına kadar tüm eğitim ihtiyaçlarını tek platformda toplayan dijital eğitim platformu.",

  contactEmail: "",
  supportPhone: "",
  whatsapp: "",
  instagram: "",
  twitter: "",
  youtube: "",
  linkedin: "",

  bankName: "",
  bankAccountName: "",
  bankIban: "",
  paytrEnabled: false,

  registrationOpen: true,
  emailVerification: true,
  allowTeacherRegistration: false,
  allowParentRegistration: true,
  maxStudentsPerClass: 30,

  emailNotifications: true,
  smsNotifications: false,
  weeklyDigest: true,
  notifyOnNewRegistration: true,

  sessionTimeoutMin: 60,
  requireStrongPassword: true,
  twoFactorRequired: false,

  maintenanceMode: false,
  maintenanceMessage:
    "Platformda bakım çalışması yapılıyor. Lütfen kısa bir süre sonra tekrar deneyin.",
  analyticsEnabled: true,
};